import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
//Antd
import { Col, Form, Input, Row, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { existeCorreo } from "../../../redux/aspirante/aspiranteDucks";
//Utilidades
import { AlertGeneric, Label } from "../../../utils";
import { valueLowerCase } from "../../../utils";
import * as uiText from "../../../utils";
import * as rules from "../../../utils";
import { linksRouter } from "../../../config/RouterLink";

//Props de inputs
const props = {
  autoComplete: "off",
};

/**
 * Componente que permite registrar el correo y contraseña del aspirante
 * @returns JSX.Element
 */
export const RegistroCorreo = ({ form }) => {
  const isMounted = useRef(true);
  const dispatch = useDispatch();
  const [validar, setValidar] = useState({});
  const { isPruebas } = useSelector((state) => state.catalogos);
  const { isValidCorreo, mensaje } = useSelector(
    (state) => state.aspirante.correo
  );

  //useEffect que valida si el componente está montado en la App.
  useEffect(() => {
    return () => {
      isMounted.current = false; //Desmontar el componente
    };
  }, []);

  const onChange = () => {
    const { getFieldValue } = form;
    let regex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;

    if (
      isMounted.current &&
      getFieldValue("email") &&
      regex.test(getFieldValue("email")) &&
      //Modo Pruebas
      !isPruebas
    ) {
      // console.log("valido");
      dispatch(existeCorreo(getFieldValue("email")));
    }
  };
  const onChangePassword = ({ target }) => {
    const { value } = target;
    const { getFieldValue } = form;
    const password = getFieldValue("passConfirma");
    if (password && password !== value) {
      setValidar({ status: "error", text: uiText.PASS_CONFIRMA_ERROR });
    } else {
      setValidar({});
    }
  };
  
  return (
    <>
      <AlertGeneric type="info" message={uiText.INFO_CORREO} />
      <Row gutter={24}>
        <Col span={6} xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
          <Form.Item
            label={<Label label={"Correo electrónico"} isRequired />}
            name="email"
            rules={[...rules.CORREO]}
            getValueFromEvent={valueLowerCase}
          >
            <Input
              maxLength={100}
              {...props}
              type="email"
              onChange={onChange}
            />
          </Form.Item>
        </Col>
        <Col span={6} xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
          <Form.Item
            label={
              <Label label={"Confirma tu correo electrónico"} isRequired />
            }
            name="emailConfirma"
            getValueFromEvent={valueLowerCase}
            rules={!isPruebas && rules.CORREO_CONFIRMA}
          >
            <Input maxLength={100} {...props} type="email" />
          </Form.Item>
        </Col>

        <Col span={6} xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
          <Form.Item
            label={
              <Tooltip
                title={
                  <ol>
                    <li>Al menos una letra mayúscula.</li>
                    <li>Mayor a 7 caracteres.</li>
                    <li>Al menos un número.</li>
                    <li>Un carácter especial (!@#$%&¿?_+:;=()/¬|{}).</li>
                  </ol>
                }
                overlayStyle={{ maxWidth: 800 }}
              >
                <Label label={"Contraseña"} isRequired />{" "}
                <QuestionCircleOutlined />
              </Tooltip>
            }
            rules={rules.PASSWORD}
            name="password"
          >
            <Input.Password
              maxLength={15}
              {...props}
              onChange={onChangePassword}
            />
          </Form.Item>
        </Col>

        <Col span={6} xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
          <Form.Item
            label={<Label label={"Confirma tu contraseña"} isRequired />}
            rules={!isPruebas && rules.PASS_CONFIRMA} //
            name="passConfirma"
            validateStatus={!isPruebas && validar?.status}
            help={!isPruebas && validar?.text}
          >
            <Input.Password
              maxLength={15}
              {...props}
              onChange={onChangePassword}
            />
          </Form.Item>
        </Col>
      </Row>

      {!isValidCorreo && (
        <AlertGeneric
          type="error"
          message={
            <>
              {mensaje}{" "}
              <Link
                to={linksRouter.correo}
                style={{
                  color: "#000",
                  textDecoration: "underline",
                  fontWeight: 600,
                }}
              >
                {uiText.INFO_PASSWORD}
              </Link>{" "}
              si no la recuerdas.
            </>
          }
        />
      )}
    </>
  );
};
